<template>
  <main-layout>
    <v-container fluid>
      <div class="mb-2">
        <date-filter
          v-model="selectedDate"
          :default-filter="'last_7_days'"
          @changeDate="onChangeDate"
        ></date-filter>
      </div>
      <div class="mb-2">
        <div class="text-xs-right">
          <exportxlsx :promised-value="getXlsxData"></exportxlsx>
        </div>
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 sm9>
            <div>
              <v-pagination
                v-model="pageNumber"
                :total-visible="6"
                :length="pagelength"
                @input="changePage"
              ></v-pagination>
            </div>
          </v-flex>
          <v-flex xs12 sm3 class="text-xs-right">
            <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>ค้นหา</v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template #items="props">
          <!-- :style="{ backgroundColor: props.item.member_status == 'true' ? '#e6ffe6' : 'white' }" -->
          <tr>
            <td v-if="PAGE.TOA_MEGA_PAINT.includes(selectedBot.pageid)">
              {{ props.item.member.first_name }} {{ props.item.member.last_name }}
            </td>
            <td v-else>{{ props.item.userdata.firstName }} {{ props.item.userdata.lastName }}</td>
            <td>
              <div>
                <span v-if="PAGE.TOA_MEGA_PAINT.includes(selectedBot.pageid)">{{
                  props.item.member.phone
                }}</span>
                <span v-else>{{ props.item.userdata.phone }}</span>
                <v-btn icon @click="onEditPhone(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
            </td>
            <td v-if="PAGE.TOA_MEGA_PAINT.includes(selectedBot.pageid)">
              {{ formatdate(props.item.member.register_timestamp) }}
            </td>
            <td v-else>{{ formatdate(props.item.userdata.timestamp) }}</td>
            <td>{{ props.item.alltime_score ? props.item.alltime_score : 0 }}</td>
            <td>{{ props.item.used_score ? props.item.used_score : 0 }}</td>
            <td>
              {{ calCurrScore(props.item.alltime_score, props.item.used_score) }}
            </td>
            <td class="text-xs-right">
              <v-btn
                color="primary"
                style="font-size: 13px"
                @click="onShowHistoryCoupon(props.item.userid || props.item.user_id)"
              >
                <span>ประวัติการแลกของรางวัล</span>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pagelength"
          @input="changePage"
        ></v-pagination>
      </div>
      <v-dialog v-model="showsearch" width="500px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <div>
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('ชื่อ') }}</label>
                  <input v-model="filter.name" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm12 class="form-control pa-1">
                  <label>{{ $t('เบอร์โทรศัพท์') }}</label>
                  <input v-model="filter.phoneNumber" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('วันที่สมัคร - start') }}</label>
                  <DatePickerWithoutButton v-model="filter.dateFrom">
                    <input
                      readonly
                      :value="formatdate(filter.dateFrom)"
                      class="form-control"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('วันที่สมัคร - end') }}</label>
                  <DatePickerWithoutButton v-model="filter.dateTo">
                    <input
                      readonly
                      :value="formatdate(filter.dateTo)"
                      class="form-control"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                </v-flex>
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
              <v-btn color="primary" @click="onsearch">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showImageDialog" width="550px">
        <div>
          <v-img
            v-if="showImageDialog"
            :src="currentShowImage"
            @click="showImageDialog = false"
          ></v-img>
        </div>
      </v-dialog>
      <v-dialog v-model="editModal" persistent width="950px">
        <v-card v-if="editModal">
          <MemberEdit
            :editdata="editdata"
            @onsave="oneditmember"
            @close="editModal = false"
          ></MemberEdit>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editPhone" persistent width="300px">
        <v-card v-if="editPhone">
          <div class="pa-2">
            <div class="text-xs-right pb-2">
              <v-btn icon outline @click="editPhone = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div class="text-xs-left form-control">
              <span>Phone: </span>
              <input
                v-model="editDataPhone.phone"
                name="phone"
                type="text"
                class="form-control"
                outline
              />
            </div>
            <div class="text-xs-center pt-2">
              <v-btn :loading="loadingSavePhone" color="primary" @click="onSavePhone">
                <span>ตกลง</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="historyCouponModal" persistent width="950px">
        <v-card v-if="historyCouponModal">
          <MemberHistoryCoupon :id="userid" @close="closeHistoryModal"> </MemberHistoryCoupon>
        </v-card>
      </v-dialog>
    </v-container>
  </main-layout>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import MemberEdit from './MemberEdit.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import api from '@/api'
import SearchMember from './SearchMember.vue'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import MemberHistoryCoupon from './MemberHistoryCoupon.vue'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint'

export default {
  components: {
    Multiselect,
    SearchMember,
    DatePickerWithoutButton,
    MemberEdit,
    exportxlsx,
    DateFilter,
    MemberHistoryCoupon
  },
  computed: {
    ...mapGetters(['selectedBot']),
    PAGE() {
      return PAGE
    },
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: 'name' },
      editModal: false,
      branchOptions: '',
      editdata: '',
      showImageDialog: false,
      currentShowImage: '',
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      showsearch: false,
      filter: {
        name: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      },
      loading: false,

      items: [],
      headers: [
        { text: 'ชื่อ-นามสกุล', value: 'name' },
        { text: 'เบอร์โทรศัพท์', value: 'phone_number' },
        { text: 'วันที่สมัคร', value: 'register_date' },
        { text: 'แต้มที่หมด', value: 'allscore' },
        { text: 'แต้มที่แลกทั้งหมด', value: 'used_score' },
        { text: 'แต้มคงเหลือ', value: 'score' },
        { text: '', value: '' }
      ],
      memberStatus: null,
      editPhone: false,
      editDataPhone: {
        userid: '',
        phone: ''
      },
      userid: '',
      historyCouponModal: false,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      isExport: false,
      lastGetData: '',
      loadingSavePhone: false
    }
  },
  mounted() {
    this.getData(false, false)
  },
  methods: {
    getXlsxData() {
      let vm = this
      return new Promise(async (resolve) => {
        this.isExport = true
        var data = await this.getData(true, false)

        resolve(
          data.map((el) => {
            let registerTimestamp = null
            let fullName = ''
            let phone = ''
            if (el.userdata) {
              registerTimestamp = el.userdata.timestamp
              fullName = `${el.userdata.firstName} ${el.userdata.lastName}`
              phone = el.userdata.phone
            } else if (el.member) {
              fullName = `${el.member.first_name} ${el.member.last_name}`
              registerTimestamp = el.member.register_timestamp
              phone = el.member.phone
            }
            return {
              ชื่อลูกค้า: fullName,
              เบอร์โทร: phone,
              วันที่สมัครสมาชิก: registerTimestamp
                ? moment(registerTimestamp).format('DD/MM/YYYY HH:mm')
                : '',
              แต้มที่หมด: el.alltime_score ? el.alltime_score : 0,
              แต้มที่แลกทั้งหมด: el.used_score ? el.used_score : 0,
              แต้มคงเหลือ: vm.calCurrScore(el.alltime_score, el.used_score)
            }
          })
        )
      })
    },
    calCurrScore(data1, data2) {
      let val1 = parseFloat(data1)
      let val2 = parseFloat(data2)
      if (val1 && !data2) {
        return val1
      } else if (val1 && val2) {
        let out = val1 - val2
        return out > 0 ? out : 0
      } else {
        return 0
      }
    },
    oneditmember() {
      this.editModal = false
      this.getData()
    },
    showEdit(item) {
      this.editdata = item
      this.editModal = true
    },
    onChangeDate() {
      this.filter = {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      }
      this.getData(false, false, 'date')
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData(false, true)
      }
    },
    onsearch() {
      this.getData(false, false, 'search')
      this.showsearch = false
    },
    clearsearch() {
      this.filter = {
        name: '',
        identityNumber: '',
        phoneNumber: '',
        dateFrom: '',
        dateTo: ''
      }
      this.onsearch()
    },
    onEditPhone(item) {
      this.editPhone = true
      this.editDataPhone.userid = item.userid || item.user_id
      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        this.editDataPhone.phone = item.member.phone
      } else {
        this.editDataPhone.phone = item.userdata.phone
      }
    },
    async onSavePhone() {
      this.loadingSavePhone = true
      let data = {
        pageid: this.selectedBot.pageid,
        userid: this.editDataPhone.userid,
        page_id: this.selectedBot.pageid,
        user_id: this.editDataPhone.userid,
        phone: this.editDataPhone.phone
      }
      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.putMember(data)
          this.editPhone = false
          this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์เรียบร้อย' })
          this.getData(false, false)
        } catch (error) {
          console.error(error)
          this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์ไม่สำเร็จ' })
        } finally {
          this.loadingSavePhone = false
        }
      } else {
        api.updateMemberPhoneToaecoupon(data, (err, response) => {
          this.loadingSavePhone = false
          if (response.responsecode == 200) {
            this.editPhone = false
            this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์เรียบร้อย' })
            this.getData(false, false)
          } else {
            this.$swal.fire({ text: 'อัพเดทเบอร์โทรศัพท์ไม่สำเร็จ' })
          }
        })
      }
    },
    formatdate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else return ''
    },
    getData(getall = false, isFirst = false, condition = 'date') {
      return new Promise(async (resolve) => {
        if (!isFirst) {
          this.offset = 0
          this.pagetmp = 1
          this.pageNumber = 1
        }

        if (this.filter.dateFrom || this.filter.dateTo) {
          condtion = 'search'
        } else {
          condition = 'date'
        }

        var data = {
          pageid: this.selectedBot.pageid,
          page_id: this.selectedBot.pageid,
          name: this.filter.name, // filter ชื่อ
          phone: this.filter.phoneNumber, // filter เบอร์
          start_date: condition == 'date' ? this.selectedDate.start : this.filter.dateFrom, // YYYY-MM-DD
          end_date: condition == 'date' ? this.selectedDate.end : this.filter.dateTo // YYYY-MM-DD
        }
        if (!getall) {
          Object.assign(data, {
            limit: this.limit,
            offset: this.offset
          })
        }

        if (this.isExport) {
          Object.assign(data, {
            limit: this.total,
            offset: this.offset
          })
        }

        this.loading = true

        if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
          try {
            let response = await toaMegapaintApi.getMember(data)
            this.loading = false
            response = response.data
            if (!getall) {
              this.items = response.data
            }
            this.total = response.total
            resolve(response.data)
          } catch (error) {
            console.error(error)
            resolve([])
          } finally {
            this.loading = false
          }
        } else {
          api.getMembersToaecoupon(data, (err, response) => {
            this.loading = false
            if (response.responsecode == 200) {
              if (!getall) {
                this.items = response.data
              }

              this.total = response.total
              resolve(response.data)
            }
          })
        }
      })
    },
    onShowHistoryCoupon(userid) {
      this.userid = userid
      this.historyCouponModal = true
    },
    closeHistoryModal() {
      this.historyCouponModal = false
    }
  }
}
</script>

<style lang="scss">
@import 'photoviewer/dist/photoviewer.css';
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Member.vue